module.exports = __webpack_public_path__ + "static/material-select-22ac28c8213148bf7d3581a8e9afecad.png";